import TextLink from 'LuxKit/TextLink'
import Caption from 'LuxKit/Typography/Caption'
import config from 'constants/config'
import GeoContext from 'contexts/geoContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { addRegionToPath } from 'lib/url/searchUrlUtils'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  modalType?: string
}

function AccountAccessLegalText({ modalType }: Props) {
  const { currentRegionCode } = React.useContext(GeoContext)
  const isPhonePromptModal = modalType === 'promptAddPhone'
  const termsURL = config.contentLinks.termsAndConditions.href || addRegionToPath(config.contentLinks.termsAndConditions.to!, currentRegionCode)
  const privacyURL = config.contentLinks.privacyPolicy.href || addRegionToPath(config.contentLinks.privacyPolicy.to!, currentRegionCode)
  const loyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)

  return (
    <Caption colour="neutral-three" variant="medium">
      {isPhonePromptModal && (
        <FormattedMessage
          id="f7gNggeLDLd_akEFMuK5"
          defaultMessage="By adding your mobile number, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> and to subscribe to marketing communications for offers, alerts and services."
          description="Legal text for phone number addition with T&Cs and privacy policy links"
          values={{
            privacyPolicy: config.brandConfig.privacyPolicySynonym,
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
      {!isPhonePromptModal && loyaltyEnabled && (
        <FormattedMessage
          id="x4zMKcjydtsCc9X7ZEH7"
          defaultMessage="By continuing, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> join the {loyaltyProgram} program, and to subscribe to marketing communications for offers, alerts and services."
          description="Legal text for sign-up with T&Cs, privacy policy, and loyalty program links"
          values={{
            privacyPolicy: config.brandConfig.privacyPolicySynonym,
            loyaltyProgram: getLoyaltyProgramDisplayName(),
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
      {!isPhonePromptModal && !loyaltyEnabled && (
        <FormattedMessage
          id="znipBfcVHP8gqcqagn18"
          defaultMessage="By continuing, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> and to subscribe to marketing communications for offers, alerts and services."
          description="Legal text for sign-up with T&Cs and privacy policy links"
          values={{
            privacyPolicy: config.brandConfig.privacyPolicySynonym,
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
    </Caption>
  )
}

export default AccountAccessLegalText
